<template>
  <v-app class="pa-3">
    <v-app-bar
      class="px-3"
      app
      flat
    >
      <a
        href="http://abriron.com"
        target="_blank"
      >
        <v-img
          v-if="$brand === 'abriron'"
          width="70"
          height="70"
          contain
          style="justify-items: start"
          class="mt-9 px-2"
          :src="logoBrand"
        />
        <v-img
          v-if="$brand !== 'abriron'"
          width="60"
          class="pt-3 px-2"
          :src="logoBrand"
        />
      </a>
      <v-spacer />
      <language v-model="lang" />
    </v-app-bar>
    <v-main>
      <v-container>
        <v-form ref="form">
          <v-card
            class="mx-auto justify-center mb-1 mt-3"
            :max-width="(isMobile ? 380 : 500)"
            :elevation="(isMobile ? 0 : 10)"
            style="border-radius: 10px"
            :flat="isMobile"
          >
            <v-row :class="{'mx-0' : !isMobile}">
              <v-card-title
                class="justify-start  my-4"
                grey
                darken-3
              >
                <h4>{{ $t('fillInformationForCompleteRegister') }}</h4>
              </v-card-title>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="firstname"
                  :label="$t('name')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  height="36"
                  hide-details
                  outlined
                  clearable
                />
              </v-col>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="lastname"
                  :label="$t('last-name')"
                  :rules="[v => !!v || $t('is-required')]"
                  dense
                  height="36"
                  hide-details
                  outlined
                  clearable
                />
              </v-col>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="email"
                  :label="$t('email')"
                  append-icon="mdi-at"
                  dense
                  height="36"
                  hide-details
                  outlined
                  clearable
                  :rules="[v => !!v || $t('is-required')]"
                />
              </v-col>
              <v-col
                class="py-0 mb-6"
                cols="12"
              >
                <v-text-field
                  v-model="abrName"
                  :label="$t('abrName')"
                  append-icon="mdi-cloud"
                  dense
                  height="36"
                  hide-details
                  :rules="[v => !!v || $t('is-required')]"
                  outlined
                  clearable
                />
              </v-col>
              <v-col
                class="py-0"
                cols="12"
              >
                <v-text-field
                  v-model="password"
                  :label="$t('password')"
                  :rules="[v => !!v || $t('is-required')]"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  dense
                  height="36"
                  hide-details
                  outlined
                  clearable
                  @click:append="show = !show"
                />
              </v-col>
              <v-col
                class="py-0"
                cols="12"
              >
                <v-radio-group
                  v-model="dateFormat"
                  class="mt-6"
                  row
                >
                  <template v-slot:label>
                    <div>{{ $t('date') }}</div>
                  </template>
                  <v-radio
                    :label="$t('jalali')"
                    value="fa,en"
                  />
                  <v-radio
                    :label="$t('gregorian')"
                    value="en,fa"
                  />
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                class="py-0 mb-6"
              >
                <autocomplete
                  v-model="currency"
                  :title="$t('currency')"
                  type="aiCurrency"
                  :set-init="true"
                  :rules="[v => !!v || $t('is-required')]"
                  :url="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="py-0 mb-6"
              >
                <v-text-field
                  v-model="yearName"
                  :label="$t('yearName')"
                  height="20"
                  dense
                  :rules="[v => !!v || $t('is-required')]"
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="py-0 mb-6"
              >
                <template>
                  <v-text-field
                    id="fromId"
                    v-model="from"
                    :label="$t('startDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    :rules="[v => !!v || $t('is-required')]"
                    dense
                    clearable
                  />

                  <date-picker
                    v-model="from"
                    element="fromId"
                    :locale="dateFormat"
                    :format="dateFormatLang"
                    auto-submit
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                cols="12"
                md="4"
                class="py-0 mb-6"
              >
                <template>
                  <v-text-field
                    id="toId"
                    v-model="to"
                    :label="$t('endDate')"
                    :rules="[v => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />

                  <date-picker
                    v-model="to"
                    element="toId"
                    :locale="dateFormat"
                    :format="dateFormatLang"
                    :min="from"
                    auto-submit
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                class="py-0 mb-3 mt-6"
                cols="12"
              >
                <v-btn
                  :loading="loading"
                  block
                  color="primary mr-0"
                  @click="submit"
                >
                  {{ $t('launch') }}
                  <v-icon
                    right
                    dark
                  >
                    mdi-keyboard_return
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-container>
    </v-main>
    <v-footer
      class="py-2"
      style="font-size: 12px;position: fixed;background-color: #fff"
      app
    >
      <v-col
        class="text-center py-1"
        cols="12"
      >
        {{ new Date().getFullYear() }} — Abriron Cloud Panel V {{ env.version }}
      </v-col>
    </v-footer>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </v-app>
</template>

<script>
  import General from '../../../../Mixins/general'
  import Snakbar from '../../components/general/snakbar/snakbar'
  import autocomplete from '../../components/general/patial/autocomplete'
  import Language from '../../components/core/LanguageBar'
  import axios from 'axios'
  export default {
    components: {
      Language,
      autocomplete,
      Snakbar,
    },
    mixins: [General],
    props: ['emailProp', 'planProp', 'phoneProp', 'phonePrefixProp'],
    data () {
      return {
        email: null,
        currency: null,
        phonePrefix: null,
        phone: null,
        plan: null,
        abrName: null,
        dateFormat: 'fa,en',
        dateFormatLang: 'YYYY/MM/DD',
        yearName: null,
        from: null,
        to: null,
        show: null,
        code: null,
        lang: null,
        firstname: null,
        lastname: null,
        username: null,
        password: null,
        has_error: false,
        text_error: null,
        loading: false,
      }
    },
    watch: {
      dateFormat () {
        this.from = null
        this.to = null
        if (this.dateFormat === 'fa,en') {
          this.dateFormatLang = 'jYYYY/jMM/jDD'
        }
        if (this.dateFormat === 'en,fa') {
          this.dateFormatLang = 'YYYY/MM/DD'
        }
      },
    },
    beforeMount () {
      if (!this.phoneProp) {
        this.goTo('register')
      }
      this.phonePrefix = this.phonePrefixProp
      this.phone = this.phoneProp
      this.plan = this.planProp
      if (this.dateFormat === 'fa,en') {
        this.dateFormatLang = 'jYYYY/jMM/jDD'
        var from = this.$moment().startOf('jYear')
        var to = this.$moment().endOf('jYear')
        this.yearName = this.$moment().jYear()
        this.from = from.format('jYYYY/jMM/jDD')
        this.to = to.format('jYYYY/jMM/jDD')
      }
      if (this.dateFormat === 'en,fa') {
        this.dateFormatLang = 'YYYY/MM/DD'
        var mfrom = this.$moment().startOf('Year')
        var mto = this.$moment().endOf('Year')
        this.yearName = this.$moment().Year()
        this.from = mfrom.format('YYYY/MM/DD')
        this.to = mto.format('YYYY/MM/DD')
      }
    },
    mounted () {
      if (localStorage.getItem('lang')) {
        this.$refs.refLang.changeLanguage(JSON.parse(localStorage.getItem('lang')))
      }
    },
    methods: {
      phoneCheck (formattedNumber, { number, valid, country }) {
        this.phonePrefix = country.dialCode
        var phoneNumber = number.input.replace(/\s/g, '')
        phoneNumber = phoneNumber.replaceAll('-', '')
        phoneNumber = phoneNumber.replace('+', '')
        this.phone = phoneNumber
      },
      submit () {
        var app = this
        app.loading = true
        delete axios.defaults.headers.common.Authorization
        app.$axios.post(this.$apipoint + 'register', app.$data)
          .then(res => {
            this.$router.push({ name: 'registerFinish', params: { phone: this.phone, lang: this.lang, password: this.password } })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (this.loading = false))
      },
      editEmail () {
        this.goTo('register')
      },
      setDate: function () {
        var m = this.$moment()
        if (!this.date) {
          var today = ''
          if (this.dateFormat === 'fa,en') {
            this.dateFormatLang = 'jYYYY/jMM/jDD'
            today = m.format('jYYYY/jMM/jDD')
          }
          if (this.dateFormat === 'en,fa') {
            this.dateFormatLang = 'YYYY/MM/DD'
            today = m.format('YYYY/MM/DD')
          }
          if (today < this.$store.state.startDate) {
            today = this.$store.state.startDate
          }
          if (today > this.$store.state.endDate) {
            today = this.$store.state.endDate
          }
          this.date = today
          return today
        }
      },
    },

  }
</script>

<style scoped>

</style>
